import React from 'react'
import { Platform } from 'react-native'

import { FormattedMessage } from 'react-intl'

import useVerifyAuth from 'app/features/ListingFeature/hooks/useVerifyAuth'
import useModal from 'app/hooks/useModal'
import { REPORT_TYPE } from 'app/utils/constants/status.constants'

import Text, { TextProps } from '../base/Text'
import ReportDialog from '../dialogs/ReportDialog'

interface ReportLinkProps {
  id: string
  type?: ReportType
  onSuccess?: () => void
  onError?: () => void
  variant?: TextProps['variant']
  sx?: TextProps['sx']
}

const ReportLink: RFC<ReportLinkProps> = ({
  id,
  type = REPORT_TYPE.listing,
  onSuccess,
  onError,
  variant = 'body2',
  sx = {},
  children
}) => {
  const checkAuth = useVerifyAuth()
  const { open, showModal, hideModal } = useModal()

  return (
    <>
      <Text
        variant={variant}
        sx={{
          ...Platform.select({
            web: {
              '&:hover': {
                cursor: 'pointer',
                color: 'secondary.dark'
              }
            }
          }),
          ...sx
        }}
        onClick={() => checkAuth(showModal)}
      >
        {children || <FormattedMessage defaultMessage="Report this item" />}
      </Text>

      {open && (
        <ReportDialog
          open={open}
          id={id}
          type={type}
          onClose={hideModal}
          onSuccess={onSuccess}
          onError={onError}
        />
      )}
    </>
  )
}

export default ReportLink
